<template>
    <div class="main-content detail" v-cloak>
        <div class="container">
            <div class="form">
                <div class="form-hor" v-if="!scoped_task_event.id">
                    <div class="form-col">
                        <custom-input
                            @change="set_value"
                            input_type="text"
                            :invalid="task_errors && task_errors.includes('name')"
                            :value="event_task.name"
                            :required="true"
                            error_msg="Error! This field is mandatory"
                            name="name"
                            label="Task name"
                        ></custom-input>
                    </div>
                </div>
                <div class="form-hor">
                    <div class="form-col">
                        <custom-input
                            @change="set_value"
                            datepicker="true"
                            :invalid="task_errors && task_errors.includes('date')"
                            icon_class="icon icon-calendar"
                            input_type="text"
                            :value="event_task.date"
                            name="date"
                            error_msg="Error! Must be selected when time picked"
                            type="text"
                            label="Deadline date"
                        ></custom-input>
                    </div>
                    <div class="form-col">
                        <custom-input
                            @change="set_value"
                            :invalid="task_errors && task_errors.includes('time')"
                            :value="event_task.time"
                            name="time"
                            :disabled="disabled"
                            timepicker="true"
                            icon_class="icon icon-time"
                            label="Deadline time"
                        ></custom-input>
                    </div>
                </div>
                <div class="form-hor">
                    <div class="form-col">
                        <custom-textarea
                            :capitalize="true"
                            limit="250"
                            hint="Hint! Max 250 characters"
                            :punctuation_capitalization="true"
                            @change="set_value"
                            label="Notes"
                            :value="event_task.notes"
                            name="notes"
                        ></custom-textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import dropdown from "@/components/pages/dropdown.vue";
import customInput from "@/components/pages/custom-input.vue";
import customTextarea from "@/components/pages/custom-textarea.vue";

export default {
    name: "tasks-add",

    components: { dropdown, customInput, customTextarea },

    computed: {
        ...mapState("StoreEvent", ["event"]),
        ...mapState("StoreEvent", ["task_errors"]),
        ...mapState("StoreEvent", ["event_task"]),

        scoped_task_event() {
            return { ...this.event_task };
        },
        disabled() {
            let is_disabled = false;
            if (!this.event_task.time) {
                if (this.event_task.date) {
                    is_disabled = false;
                } else {
                    is_disabled = true;
                }
            } else {
                is_disabled = false;
            }
            return is_disabled;
        }
    },

    watch: {
        event_task: {
            handler: function(new_val, oldVal) {
                if (new_val.id && oldVal.id) {
                    if (new_val.notes) {
                        this.set_event_task_save_btn_disabled(true);
                    }
                    if (new_val.date) {
                        this.set_event_task_save_btn_disabled(true);
                    }
                    if (new_val.time) {
                        this.set_event_task_save_btn_disabled(true);
                    }
                }
            },
            deep: true
        }
    },
    data() {
        return {};
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.set_empty_task_event();
            if (to.params && to.params.id) {
                vm.update_event_task_field({ prop_name: "event_id", prop_value: to.params.id });
            }
            if (to.params && to.params.task_id) {
                vm.set_event_task_save_btn_disabled(false);
                vm.get_current_task_event(to.params.task_id);
            }
            next();
        });
    },
    mounted() {},

    methods: {
        ...mapMutations("StoreEvent", [
            "update_event_task_field",
            "set_task_event_btn_mode",
            "clear_task_event",
            "set_event_task_save_btn_disabled"
        ]),
        ...mapActions("StoreEvent", ["get_task_event"]),
        set_empty_task_event() {
            this.clear_task_event();
        },
        get_current_task_event(task_id) {
            this.get_task_event(task_id);
        },
        set_value(args) {
            this.update_event_task_field(args);
            if (this.validate_event()) {
                this.set_task_event_btn_mode(true);
            } else {
                this.set_task_event_btn_mode(false);
            }
        },
        validate_event() {
            if (this.event_task.name && this.event_task.name.trim()) {
                if (!this.event_task.time) {
                    return true;
                }
            } else {
                return false;
            }
            if (this.event_task.name && this.event_task.time) {
                if (/^\d{2}:\d{2}$/.test(this.event_task.time)) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
};
</script>

<style scoped>
@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow: auto;
    }
}
</style>
